import React from 'react';
import HrnbCard from '../controls/HrnbCard';
import '../../css/rules/RuleCard.css';

/**
 * Карточка правила
 * Отображает: title, content, order, battleId
 */
export default function RuleCard({ rule, className = "" }) {
    if (!rule) return null;

    const { title, content, order, battleId, createdAt } = rule;

    return (
        <HrnbCard
            className={`rule-card ${className}`}
            title={title}
            subtitle={battleId ? `Баттл #${battleId}` : 'Общее правило'}
            actions={
                order !== undefined && (
                    <span className="rule-card__order">
                        #{order}
                    </span>
                )
            }
        >
            <div className="rule-card__content">
                <p className="rule-card__description">{content}</p>
                {createdAt && (
                    <div className="rule-card__meta">
                        <small>Добавлено: {new Date(createdAt).toLocaleDateString()}</small>
                    </div>
                )}
            </div>
        </HrnbCard>
    );
}
